import { createAction, props } from '@ngrx/store';
import { TopTeamFlags } from '@app/home/services/models/our-specialists-model';

const TOP_TEAM = 'TOP_TEAM';

export const getTopTeam = createAction(
  `[${TOP_TEAM}] Get Top Team`,
  props<{ filter: { pageNumber: number; pageSize: number; sortBy?: string; direction?: string; agentGroupFlagTypes?: TopTeamFlags[] } }>(),
);
export const getTopTeamSuccess = createAction(`[${TOP_TEAM}] Get Top Team Success`, props<{ topTeam: any[], totalCount: number }>());
export const getTopTeamFailure = createAction(`[${TOP_TEAM}] Get Top Team Failure`, props<{ errorMessage: string }>());

export const getMoreTopTeam = createAction(
  `[${TOP_TEAM}] Get More Top Team`,
  props<{ filter: { pageNumber: number; pageSize: number; sortBy?: string; direction?: string; agentGroupFlagTypes?: TopTeamFlags[] } }>(),
);
export const getMoreTopTeamSuccess = createAction(`[${TOP_TEAM}] Get More Top Team Success`, props<{ topTeam: any[], totalCount: number }>());
export const getMoreTopTeamFailure = createAction(`[${TOP_TEAM}] Get More Top Team Failure`, props<{ errorMessage: string }>());
